<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}
  section.u-mt-md
    .grid.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-xm(:title="$t('sec3')" tag="h2")
        p {{$t('sec3Desc')}}
  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Editorial design",
    "pageDesc":"Providing editorial design service for all publications  such as magazines, newspapers, catalogues, menus, books, among others.",
    "mantra":"Creating smart |editorial layouts.",
    "sec1":"Book design",
    "sec1Items":{
      "1":{
        "title":"Layout Design",
        "desc":"Highlighting the utmost value behind your writing by using custom layouts to align texts, imagery, quotes and other types of content in a flow that maximizes reading enjoyment. "
      },
      "2":{
        "title":"Cover Design",
        "desc":"Fusing your writing style with readers’ interests to come up with an eye rolling cover design. We enjoy playing with different design techniques to innovate new types of book artwork."
      },
      "3":{
        "title":"Interior Illustrations",
        "desc":"Decorating your text with graphs, charts and custom illustrations to further explain your ideas and keep your users entraintained with each page flip.  "
      }
    },
    "sec2":"Magazine design that leverages on all editorial styles.",
    "sec2Items":{
      "1":{
        "title":"Illustration",
        "desc":"Expressing your content in a vivid and very catching manner through various illustration techniques and writing styles that creates moods for your readers."
      },
      "2":{
        "title":"Photography",
        "desc":"Enhancing your magazine visual appearance by balancing imagery and texts and doing the needed retouches to match them together."
      },
      "3":{
        "title":"Typography",
        "desc":"Playing with font sizes, weights, different types and creating visual consistency with bulks of words placed near."
      }
    },
    "sec3":"Poster design",
    "sec3Desc":"Whether on social media or offline advertising campaigns, we help you reach with your audience and creates unforgettable experience by combining the basic editorial elements like format, identity, structure, art, typography, layout, and production techniques.",
    "cta":"Custom your <br> publications"
  },
  "ar": {
    "pageTitle":"التصميم التحريري",
    "pageDesc":"نوفر لك  خدمة تصميم المطبوعات لجميع المنشورات مثل المجلات والصحف والكتالوجات والقوائم والكتب وغيرها.",
    "mantra":"التصميم التحريري لمطبوعات |تتناسب مع روح هويتك.",
    "sec1":"تصميم الكتب",
    "sec1Items":{
      "1":{
        "title":"تصميم المخطط",
        "desc":"سلط الضوء على القيمة وراء كتابتك باستخدام تخطيطات مخصصة لمحاذاة النصوص والصور والاقتباسات وأنواع المحتوى الأخرى مما يزيد من متعة القراءة من خلال تجربة مريحة."
      },
      "2":{
        "title":"تصميم الغلاف",
        "desc":"ادمج أسلوب الكتابة الخاص بك مع اهتمامات القراء للتوصل إلى تصميم غلاف يجذب العين. نبتكر تقنيات تصميمة مختلفة لابتكار أغلفة مميزة تلفت الانتباه من اللحظة الأولي."
      },
      "3":{
        "title":"الرسوم التوضيحية الداخلية",
        "desc":"نزين النص الخاص بك بالرسوم البيانية والرسوم التوضيحية المخصصة لشرح أفكارك بصورة أكثر عمقًا وتوصيل فكرتك حتى يكون من السهل على القارئ فهم المعنى العام لما تكتبه بدون أي تعب."
      }
    },
    "sec2":"صمم مجلتك باحترافية.",
    "sec2Items":{
      "1":{
        "title":"الإليستريشن",
        "desc":"عبرعن المحتوى الخاص بك بطريقة حية وجذابة للغاية من خلال تقنيات الإليستريشن وأنماط الكتابة المختلفة التي تخلق مزاجًا مختلفًا أثناء القراءة."
      },
      "2":{
        "title":"التصوير",
        "desc":"حسّن المظهر البصري لمجلتك من خلال موازنة الصور والنصوص والقيام   باللمسات النهائية التي تعطي التصميم شكله الجمالي."
      },
      "3":{
        "title":"التايبوجرافي",
        "desc":"العب بأحجام الخطوط والأوزان والأنواع المختلفة وقم إنشاء تناسق بصري من خلال الكلمات."
      }
    },
    "sec3":"تصميم البوسترات",
    "sec3Desc":"سواء على وسائل التواصل الاجتماعي أو الحملات الإعلانية الأوفلاين، نساعدك على التواصل مع جمهورك وخلق تجربة لا تُنسى من خلال الجمع بين العناصر الأساسية مثل التنسيق والهوية والتخطيط والتيبوجرافي وتقنيات الإنتاج.",
    "cta":"صمم مطبوعاتك <br> الآن!"
  }
}
</i18n>
